import { getPromoReviews, getServiceStatistics, getTravelersFaq } from '@/shared/api/generated/api';

export const getAboutLandingData = async () => {
  const [statisticsResponse, faqResponse, reviewsResponse] = await Promise.all([
    getServiceStatistics(),
    getTravelersFaq({
      query: {
        with_answers: true,
      },
    }),
    getPromoReviews({
      query: {
        promo: true,
      },
    }).catch(() => null),
  ]);

  if (!statisticsResponse.data || !faqResponse.data) {
    throw new Error('About landing response is empty');
  }

  return {
    faq: faqResponse.data,
    reviews: reviewsResponse?.data?.results ?? [],
    statistics: statisticsResponse.data,
  };
};
